import SimpleRadio from './SimpleRadio';

export default SimpleRadio;
